import { FruitProps } from "../../../../actions/Layers/constants";
import { path_atron, path_atron_results, path_mangos, path_manual_check, path_manual_or_with_mini, path_results_with_form } from "../../../../actions/Tenants/config/constants";
import { AvocadoIndex } from "../../AddItem/components/Images";
import { DataSource } from "./Field";
import FruitField from "./FruitField";

function getPathForEditFruit(flow) {
    const possible_fruit_paths = [
        path_manual_or_with_mini,
        path_manual_check,
        path_results_with_form,
        path_atron_results,
        path_atron,
        path_mangos,
    ];
    return flow?.find(({ path }) => possible_fruit_paths.includes(path))?.path || path_manual_check;
}

export default class FruitIndexField extends FruitField {

    set_value(datasource: DataSource): this {
        const { check, fruit, config } = datasource;
        if (!fruit || !check || !config) {
            return this.setEmptyValue();
        }

        const fruitList: FruitProps[] = check.avocados || [];
        const index = fruitList.findIndex((f) => f.avocado_id === fruit.avocado_id);

        if (index === -1) {
            return this.setEmptyValue();
        }


        this.value = index + 1;
        this.datasource = datasource;
        return this;
    }

    setEmptyValue(): this {
        this.value = "-";
        return this;
    }

    display_component(): JSX.Element {
        const { fruit, layer, check, config } = this.datasource!;
        if (this.value === "-" || !fruit || !check) return <span>-</span>;
        const location = config.get_check_type_config(layer, check);
        const fruit_path = getPathForEditFruit(location?.flow);
        return <AvocadoIndex avocado={fruit} key={fruit.avocado_id} index={this.value as number} fruit_path={fruit_path} />;
    }
}
